export default function validateExperience(experienceList) {
  const errors = [];
  const warnings = [];
  const list = experienceList || [];
  
  if (list.length === 0) {
    errors.push("At least one work experience entry is required.");
  } else {
    list.forEach((exp, idx) => {
      const label = exp.company || exp.role || `Entry #${idx + 1}`;
      if (!exp.company || !exp.company.trim()) {
        errors.push(`[${label}] Company name is missing.`);
      }
      if (!exp.role || !exp.role.trim()) {
        errors.push(`[${label}] Job title/role is missing.`);
      }
      if (!exp.duration || !exp.duration.trim()) {
        warnings.push(`[${label}] Employment duration/dates missing.`);
      }
      const bullets = exp.points || exp.responsibilities || [];
      if (bullets.length === 0) {
        warnings.push(`[${label}] Bullet points are missing.`);
      } else {
        bullets.forEach((b, bIdx) => {
          if (!b || !b.trim()) {
            warnings.push(`[${label}] Bullet point #${bIdx + 1} is empty.`);
          }
        });
      }
    });
  }

  // Calculate percentage based on filled key items
  let percentage = 0;
  if (list.length > 0) {
    let score = 0;
    list.forEach(exp => {
      if (exp.company?.trim()) score += 25;
      if (exp.role?.trim()) score += 25;
      if (exp.duration?.trim()) score += 25;
      const bullets = exp.points || exp.responsibilities || [];
      if (bullets.length > 0 && bullets[0]?.trim()) score += 25;
    });
    percentage = Math.round(score / list.length);
  }

  return {
    id: "experience",
    completed: errors.length === 0,
    percentage,
    errors,
    warnings
  };
}
